import {
  getTokenCookie,
  hasTokenCookie,
} from "common/context/auth/token-cookie";
import { rest } from "common/api-client/rest";
import apiURL from "common/config/api-url.config";

export type UserInfoResponse = {
  id: number;
  name: string;
  email: string;
  token: string;
  roles: {
    value: string;
    label: string;
  }[];
};

export type UserInfo = Omit<UserInfoResponse, "token"> | null;

type SuccessfulUserResponse = UserInfoResponse & { validation: true };
export type TokenValidationResponse =
  | SuccessfulUserResponse
  | { validation: false; message?: string };

export async function tokenValidation() {
  if (!hasTokenCookie()) {
    return null;
  }

  const result = await rest<TokenValidationResponse>("auth/tokenValidation", {
    baseURL: apiURL,
    headers: {
      Authorization: `Bearer ${getTokenCookie()}`,
    },
  });

  if (result instanceof Error) {
    return null;
  }
  if (result.kind === "empty") {
    throw new Error("Response does not have a body");
  }

  if (!result.body.validation) {
    return null;
  }

  const {
    body: { id, name, email, roles },
  } = result;

  const user: UserInfo = {
    id,
    name,
    email,
    roles,
  };
  return user;
}
